import { routes } from "@/config/routes";
import { EDefaultUserSettingRoute } from "../enums/DefaultUserSetting";

export function getHomePage(
  defaultHomeRoute?: EDefaultUserSettingRoute
): string {
  if (defaultHomeRoute === EDefaultUserSettingRoute.ALL_LEADS)
    return routes.contacts.listing;

  return routes.dashboard;
}
